import { Map } from 'immutable'
import { handleActions, combineActions } from 'redux-actions'
import { each } from 'lodash'
import { keyBy } from 'utils/immutable'
import { actions } from 'app/modules/user'
import * as ProfileActions from 'app/modules/profile/actions'
import * as TeamsActions from 'app/modules/teams/actions'
import * as OrgActions from 'app/modules/org/actions'
import { User, Enrichment } from './models'
import { parseUser } from 'app/modules/user/api'

// In the future gates should live in a separate module
function preserveGatesAndScopes(oldVal, newVal, key) {
  if (key === 'gates') {
    if (oldVal.isEmpty()) {
      return newVal
    }

    return oldVal
  }

  if (key === 'scopes') {
    if (!oldVal || oldVal.length === 0) {
      return newVal
    }

    return oldVal
  }

  return newVal
}

export const currentUser = handleActions(
  {
    [actions.fetchClearbitForEmailSuccess]: (state, action) => {
      const attributes = action.payload.get('attributes')
      if (attributes) {
        return state.set('enrichment', Enrichment(attributes))
      }
      return state
    },

    [actions.fetchGoogleScopesSuccess]: (state, action) => {
      return state.set('googleScopes', action.payload)
    },

    [combineActions(actions.fetchEmailSignatureSuccess, actions.setEmailSignatureSuccess)]: (
      state,
      action
    ) => {
      return state.set('emailSignature', action.payload)
    },

    [combineActions(
      actions.fetchGoogleScopesPending,
      actions.fetchGoogleScopesFailed,
      actions.fetchGoogleScopesSuccess
    )]: (state, action) => state.set('googleScopesStatus', action.type),

    [actions.receiveCurrentUser]: (state, action) => {
      const user = state.get('user', User())
      return state.set('user', user.mergeWith(preserveGatesAndScopes, action.payload))
    },

    // TODO: deprecated, remove when multi signature banners is ready
    [combineActions(
      actions.fetchOrgSignature,
      actions.fetchOrgSignaturePending,
      actions.fetchOrgSignatureFailed,
      actions.fetchOrgSignatureCancelled,
      actions.fetchOrgSignatureSuccess
    )]: (state, action) => state.setIn(['orgSignature', 'status'], action.type),

    [combineActions(actions.fetchOrgSignatureSuccess, actions.fetchOrgSignatureFailed)]: (state, action) =>
      state.setIn(['orgSignature', 'data'], action.payload),

    [combineActions(
      actions.fetchOrgMultiSignature,
      actions.fetchOrgMultiSignaturePending,
      actions.fetchOrgMultiSignatureFailed,
      actions.fetchOrgMultiSignatureCancelled,
      actions.fetchOrgMultiSignatureSuccess
    )]: (state, action) => state.setIn(['orgMultiSignature', 'status'], action.type),

    [combineActions(actions.fetchOrgMultiSignatureSuccess, actions.fetchOrgMultiSignatureFailed)]: (state, action) =>
      state.setIn(['orgMultiSignature', 'data'], action.payload),

    [actions.receiveGates]: (state, action) => {
      return state.setIn(['user', 'gates'], action.payload)
    },

    [actions.receiveOrgUsers]: (state, action) => {
      return state.set('orgUsers', keyBy(action.payload))
    },

    [actions.receiveOrgUser]: (state, action) => {
      return state.setIn(['orgUsers', action.payload.id], action.payload)
    },

    [ProfileActions.fetchUserProfileSuccess]: (state, action) => {
      const { userId, profile } = action.payload
      return state.setIn(['orgUsers', userId, 'profile'], profile)
    },

    [TeamsActions.fetchTeamsForUserSuccess]: (state, action) => {
      const { userId, teams } = action.payload
      return state.setIn(['orgUsers', userId, 'teams'], teams)
    },

    [OrgActions.receiveUserScopes]: (state, action) => {
      const userIds = Object.keys(action.payload)

      return state.withMutations(_state => {
        each(userIds, userId =>
          _state.setIn(['orgUsers', parseInt(userId), 'scopes'], action.payload[userId])
        )
      })
    },

    [combineActions(
      actions.fetchCurrentUserStarted,
      actions.receiveCurrentUser,
      actions.fetchCurrentUserFailed
    )]: (state, action) => {
      return state.setIn(['status', 'currentUser'], action.type)
    },

    [combineActions(actions.fetchOrgUsersStarted, actions.fetchOrgUsersFailed, actions.receiveOrgUsers)]: (
      state,
      action
    ) => {
      return state.setIn(['status', 'orgUsers'], action.type)
    },

    [actions.fetchCurrentUserFailed]: (state, action) => {
      return state.set('error', action.payload)
    },

    [actions.disconnectGmailAccountSuccess]: state => {
      return state.withMutations(state => {
        return state.set('googleScopes', [])
      })
    },

    [combineActions(
      actions.fetchIndividualUserConvoLimit,
      actions.fetchIndividualUserConvoLimitPending,
      actions.fetchIndividualUserConvoLimitFailed,
      actions.fetchIndividualUserConvoLimitCancelled,
    )]: (state, action) => state.setIn(['userConvoLimits', action.payload.userId, 'status'], action.type),

    [actions.fetchIndividualUserConvoLimitSuccess]: (state, action) => state
        .setIn(['userConvoLimits', action.payload.userId, 'status'], action.type)
        .setIn(['userConvoLimits', action.payload.userId, 'data'], action.payload.data),

    [actions.updateIndividualUserConvoLimitSuccess]: (state, action) => state
        .setIn(['userConvoLimits', action.payload.userId, 'status'], action.type)
        .setIn(['userConvoLimits', action.payload.userId, 'data'], action.payload.data),

    // perform an optimistic update
    [actions.updateUserPending]: (state, { payload }) => state
        .set('lastUpdatedUser', null)
        .setIn(['status', 'updateUser'], 'pending')
        .updateIn(['orgUsers', payload.id], user => {
          const { scopes, availability } = payload
          return user.merge({ scopes, availability })
        }),

    [actions.updateUserSuccess]: (state, { payload }) => state
        .setIn(['status', 'updateUser'], 'success')
        .set('lastUpdatedUser', payload),

    // revert to original
    [actions.updateUserFailed]: (state, action) => state
        .set('lastUpdatedUser', null)
        .setIn(['status', 'updateUser'], 'failed')
        .setIn(['orgUsers', action.payload.id], parseUser(action.payload)),
  },
  Map({
    enrichment: Enrichment(),
  })
 )



// WEBPACK FOOTER //
// ./src/scripts/app/modules/user/reducers.js